const SELECT_NAME = "Select";
const WINDOW_PADDING = 8;
const SCROLL_ARROW_VELOCITY = 8;
const SCROLL_ARROW_THRESHOLD = 8;
const MIN_HEIGHT = 80;
const FALLBACK_THRESHOLD = 16;
const VIEWPORT_NAME = "SelectViewport";
export {
  FALLBACK_THRESHOLD,
  MIN_HEIGHT,
  SCROLL_ARROW_THRESHOLD,
  SCROLL_ARROW_VELOCITY,
  SELECT_NAME,
  VIEWPORT_NAME,
  WINDOW_PADDING
};
//# sourceMappingURL=constants.js.map
